<div class="col col-max">
  @if (isValidSerasaAlerta && isValidSerasaAlertaTransaction) {
    <button id="button-central-monitoramento"
      eds-button motif="primary"
      class="btn-primary-card"
      appAnalyticsButton launchSection="MenuDeProdutos:SerasaAlerta"
      [launchLabel]="alertCountCentralMonitoring ? 'Serasa Alerta-notification' : 'Serasa Alerta-no-notification'"
      (click)="redirectToSerasaAlerta()">
      <span class="material-icons s18 icon-space">visibility</span>
      Serasa Alerta
      @if (alertCountCentralMonitoring) {
        <span class="badge">+</span>
      }
    </button>
  }
</div>
